__turbopack_context__.v({
  "cards": "mGdbOW_cards",
  "content": "mGdbOW_content",
  "headContact": "mGdbOW_headContact",
  "p": "mGdbOW_p",
  "p1": "mGdbOW_p1",
  "page-body-wrap": "mGdbOW_page-body-wrap",
  "paragraph": "mGdbOW_paragraph",
  "paragraph-content": "mGdbOW_paragraph-content",
  "t": "mGdbOW_t",
  "title": "mGdbOW_title",
  "wrap-container": "mGdbOW_wrap-container",
  "wrap-content": "mGdbOW_wrap-content",
});
